import React, { useState, useRef, useEffect, useCallback } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Container,
    Card,
    styled,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    ListItemButton,
    List,
    Chip,
    ListItem,
    ListItemText,
    ListSubheader,
    TableContainer,
    TableCell,
    Table,
    TableHead,
    TableRow,
    TableBody,
    FormControlLabel,
    FormGroup,
    Checkbox,
    ButtonGroup,
    Tooltip,
    Fab,
    Link
} from '@mui/material';

// import {
//   LoadingButton
// } from '@mui/lab';

import { green, grey, red, yellow } from "@mui/material/colors";

import dayjs from "dayjs";

import { useNavigate, useParams } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext"

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import { CommonIcons, icons } from "../../common/CommonIcons"

import LocationSelector from "../../selector/LocationSelector";

import SearchPackDocuments from "../../dialog/SearchPackDocuments"

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useDocuments, documentTypes, targetTypes as documentTargetTypes } from "../../../hooks/api/useDocuments";
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useRepositories, repositoryTypes, targetTypes as repositoryTargetTypes } from "../../../hooks/api/useRepositories";
import { useItems, itemTypes } from "../../../hooks/api/useItems";

import { checkValueExists } from "../../../utils/dataSchema";
import { getUId } from "../../../utils/formatId"
import { getUniqueValuesInArray } from "../../../utils/formatArray"
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';

import {
    packingMethods,
    validationSchema,
    initialValues,
    initialRowValues,
    initialPackagePackagesRowValues,
    buildAddressKey
} from "../../../schema/repositories/packagePackSchema"


import SectionPackages from "./sections/SectionPackages";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    // opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function PackPackage({
    routeType
}) {

    // const { id } = useParams();

    const navigate = useNavigate()
    // const [ searchParams, setSearchParams ] = useSearchParams()

    // const { authData, getAvailableLocations } = useAuthAccess();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.repository.id, scopeTypes.repository.package.id)

    const { setSystemLoading, getLocationIds, setLocationIds, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures();

    const {
        list: listPackages,
        create: createPackage,
        update: updatePackage,
        filterOperatorTypes
    } = useRepositories({ repositoryType: repositoryTypes.package, targetType: repositoryTargetTypes.package })

    // const { create: createDocument } = useDocuments(documentTypes.packingOrder, documentTargetTypes.packingOrder)

    const { list: listUoms } = useItems({ itemType: itemTypes.uom })

    const [dataUoms, setDataUoms] = useState([])
    const [allMaxQty, setAllMaxQty] = useState(false)

    const [dataSavedPackages, setDataSavedPackages] = useState([])

    const [searchDocumentConfig, setSearchDocumentConfig] = useState({
        show: false,
        documentType: [documentTypes.deliveryOrder],
        presetDocumentType: documentTypes.deliveryOrder,
        keyword: ""
    })

    const [addressKey, setAddressKey] = useState("")

    const fetchUoms = async (keyword) => {

        setSystemLoading(true)

        try {

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    // {
                    //     name: "number_alternative",
                    //     operator: filterOperatorTypes.eq,
                    //     value: keyword
                    // }
                ]
            }

            const { data } = await listUoms(props)

            // console.log('data', data)

            setDataUoms(data?.item_uoms ? data.item_uoms : [])


        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

        return false;

    }

    const fetchPackagesByDocuments = async () => {

        setSystemLoading(true)

        try {

            // getting all selected documents
            let documentNos = getUniqueValuesInArray({ array: values.rows, uniqueKey: "documentNumber" })

            if (documentNos.length <= 0) {
                throw new Error(`No document selected`)
                // console.error(`No document selected`)
                // return false;
            }

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "repo_number",
                    dir: -1,
                },
                filterValue: [
                    {
                        name: "doc_number",
                        operator: filterOperatorTypes.havingInOr,
                        value: JSON.stringify(documentNos)
                    }
                ]
            }

            // console.log('do', documentNos)

            // [{"field":"doc_number","operator":"having_in_or","value":"[\"DO-231200350\",\"DO-231200349\"]"}]

            const { data } = await listPackages(props)

            // console.log('data', data)

            setDataSavedPackages(data?.repositories ? data.repositories : [])

            // setDataUoms(data?.item_uoms? data.item_uoms : [])

            // return true;

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

        // return false;

    }

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            let operationDate = dayjs().format("YYYY-MM-DD")

            // create package 
            let repository = {
                number_alternative: getUId({ version: 1 }),
                repo_date: operationDate,
                remark: currentValues.package.remark
            }

            let props = {
                location_id: currentValues.locationId,
                uom_id: currentValues.package.uomId,
                uom_lbl: currentValues.package.uomName,
                packing_type: currentValues.package.method,
            }

            // to get different related document
            // check if is lumpsum
            if (currentValues.package.method === packingMethods.lumpsum.id) {
                props.document_id = getUniqueValuesInArray({ array: currentValues.rows, uniqueKey: "documentId" }) // make sure no duplicate values
            } else { // for other packing method - existing or new
                let selectedRows = currentValues.rows.filter(i => parseFloat(i.qty.value) > 0) // only take the document have selected qty item
                props.document_id = getUniqueValuesInArray({ array: selectedRows, uniqueKey: "documentId" }) // make sure no duplicate values
            }

            let items = []

            currentValues.rows.forEach(i => {
                if (parseFloat(i.qty.value) > 0) { // only if the qty is selected
                    items.push({
                        id: i.itemId,
                        code: i.code,
                        name: i.name,
                        description: i?.description,
                        qty: i.qty.value,
                        uom_lbl: i?.uomName,
                        uom: i?.uomId,
                        price: i?.price,
                        props: {
                            document_item_id: i?.docItemId
                        }
                    })
                }
            })

            let data = {
                repository,
                props,
                items
            }

            // check method : new 
            if (currentValues.package.method === packingMethods.new.id) {

                const responsePackage = await createPackage({ data })

                const packageId = responsePackage?.data?.repository?.id ? responsePackage.data.repository.id : ""

                promptMessage(true, `${responsePackage?.message}`)

                // check method : existing 
            } else if (currentValues.package.method === packingMethods.existing.id) {

                // need to check the package no is exist - valid
                const props = {
                    limit: -1,
                    skip: 0,
                    sortInfo: {
                        id: "repo_number",
                        dir: -1,
                    },
                    filterValue: [
                        {
                            name: "number_alternative",
                            operator: filterOperatorTypes.eq,
                            value: currentValues.package.packageNo
                        }
                    ]
                }

                const { data: searchData } = await listPackages(props)

                // console.log('searchData', searchData)

                if (searchData?.repositories) {

                    // check the items assigned
                    if (searchData.repositories[0]?.items.length > 0) {
                        throw new Error(`Package No. has items assigned. Cannot override items`)
                    }

                    let packageId = searchData.repositories[0]?.id
                    // console.log('packageId', packageId)

                    if (packageId) {

                        data.props.location_id = searchData.repositories[0].location_id
                        data.props.uom_id = searchData.repositories[0].uom_id
                        data.props.uom_lbl = searchData.repositories[0].uom_lbl
                        data.props.packing_type = packingMethods.existing.id

                        const responsePackage = await updatePackage({ id: packageId, data })

                        console.log('responsePackage', responsePackage, packageId)

                        promptMessage(true, `${responsePackage?.message}`)
                    } else {
                        throw new Error(`Invalid Package No.`)
                    }

                } else {
                    throw new Error(`Invalid Package No.`)
                }


            } else if (currentValues.package.method === packingMethods.lumpsum.id) { // for lumpsum

                // create array
                let myArray = [];

                let total = currentValues.package.packages.forEach((e1, index) => {
                    for (let i = 0; i < parseInt(e1.qty, 10); i += 1) {
                        myArray.push(e1)
                    }
                })

                // console.log('myArray', myArray)

                await Promise.all(

                    // Use map to create an array of promises,  
                    // with one promise for each item in myArray. 
                    myArray.map(async (item, index) => {

                        // get unique id
                        const uuid = getUId({ version: 1 })

                        // override the repository
                        data.repository.number_alternative = uuid

                        // overrride the props 
                        data.props.uom_id = item.uomId
                        data.props.uom_lbl = item.uomName

                        // if(index > 0){
                        // reset the items for the second package onwards
                        // data.items = []
                        // }

                        const responsePackageLumpsum = await createPackage({ data })

                    })

                );

                promptMessage(true, `Packages packing submitted`)

            }

            resetAllQtyInput()
            setAllMaxQty(false)


        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)


    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
        enableReinitialize: true
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue } = formik;

    useEffect(() => {

        fetchUoms()

    }, [])

    useEffect(() => {

        fetchPackagesByDocuments()

    }, [values.rows])

    useEffect(() => {

        // need to update back the maxQty to the state once the new saved packages obtained
        values.rows.forEach((e, index) => {

            let docItemId = e.docItemId
            let newMaxQty = getMaxQtyByDocItemId(docItemId)

            setFieldValue(`rows.${index}.qty.maxQty`, newMaxQty)

        })

    }, [dataSavedPackages])


    const openRelatedPackages = () => {

        // getting all selected documents
        let documentNos = getUniqueValuesInArray({ array: values.rows, uniqueKey: "documentNumber" })

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: `Related Packages`,
            PaperProps: {
                sx: {
                    width: 2 / 5
                }
            },
            handleOnClose: () => { fetchPackagesByDocuments() },
            ComponentActions:
                <>
                    {/* <Button
                        variant="contained"
                        // color={"primary"}
                        size="small"
                        onClick={() => openNew({ row, rackData })}
                    >
                        New Validation
                    </Button> */}
                </>,
            ComponentBody:
                <SectionPackages
                    // data={dataSavedPackages}
                    routeType={routeType}
                    locationId={values?.locationId}
                    documentNos={documentNos}
                    documentIds={
                        getUniqueValuesInArray({ array: values.rows, uniqueKey: "documentId" })
                    }
                    dataUoms={dataUoms}
                />
        })
    }

    // check the add document is same delivery address
    const checkSameAddress = ({ data }) => {

        let selectedAddressKey = buildAddressKey({ data })
        // console.log('addressKey', addressKey)

        if (addressKey === "") {
            setAddressKey(selectedAddressKey)
        } else if (selectedAddressKey !== addressKey) {
            throw new Error(`Selected document are not having same delivery address`)
        }

    }

    // calculate the total saved pack use qty for the doc id
    const getTotalPackedQtyByDocId = (id) => {

        let totalItemPacked = 0;

        dataSavedPackages.forEach(e => {

            // loop for all items
            const selected = e.items.filter(i => i.document_id === id)
            let totalUsed = 0;

            if (selected.length) {
                totalUsed = selected.reduce((total, i) => total + parseFloat(i.qty), 0)
            }

            totalItemPacked += totalUsed

        })

        return totalItemPacked;
    }

    // calculate the total saved pack use qty for the doc item id
    const getTotalPackedQtyByDocItemId = (id) => {

        let totalItemPacked = 0;

        dataSavedPackages.forEach(e => {
            // loop for all items
            const selected = e.items.filter(i => i.document_item_id === id)
            let totalUsed = 0;

            if (selected.length) {
                totalUsed = selected.reduce((total, i) => total + parseFloat(i.qty), 0)
            }

            totalItemPacked += totalUsed

        })

        return totalItemPacked;
    }

    // calculate the itemQty total allow for the doc id
    const getTotalItemQtyByDocId = (docId) => {
        // get current states
        const selected = values.rows.filter(i => i.documentId === docId)
        // const currentItemQty = selected.length? selected[0].qty.itemQty : 0

        const total = selected.reduce((total, i) => total + parseFloat(i.qty.itemQty), 0)

        return total
    }

    // calculate the maxQty allow for the doc item id
    const getMaxQtyByDocItemId = (docItemId) => {
        // get current states
        const selected = values.rows.filter(i => i.docItemId === docItemId)
        const currentItemQty = selected.length ? selected[0].qty.itemQty : 0

        return (currentItemQty - parseFloat(getTotalPackedQtyByDocItemId(docItemId)))
    }

    // check the doc item is fully packed
    const checkDocItemIsDone = (docItemId) => {
        return getMaxQtyByDocItemId(docItemId) <= 0
    }

    const resetAllQtyInput = () => {

        const rows = values.rows.map((i, index) => ({
            ...values.rows[index],
            qty: {
                value: "0",
                maxQty: i.qty.maxQty,
                itemQty: i.qty.itemQty
            }
        }))

        setFieldValue(`rows`, rows)
    }

    const checkDocumentIsSelected = async ({ documentId }) => {

        const selected = values.rows.filter(i => i.documentId === documentId)

        // console.log('aa', selected, documentId)

        return selected.length;

    }

    const getTotalQtySelected = () => {
        return values.rows.reduce((total, i) => total + parseFloat(i?.qty?.value ? i.qty.value : 0), 0)
    }

    // const handleSearchPackage = async () => {

    //     try{

    //         // check empty input
    //         // if(!values?.searchPackageNo){
    //         //     throw new Error(`Please enter the package number`)
    //         // }

    //         // // check dupliate selection
    //         // const checkDuplicate = values?.packages.filter(i => i.packageNumber === values.searchPackageNo)

    //         // // console.log('checkDuplicate', checkDuplicate)

    //         // if(checkDuplicate.length){
    //         //     throw new Error(`You have already selected this package : ${values.searchPackageNo}`)
    //         // }

    //         // const packageSelected = await fetchDataPackages(values?.searchPackageNo)

    //         // // console.log('packageSelected', packageSelected)

    //         // if(packageSelected !== false){

    //         //     // final check 
    //         //     // check the package is already packed status
    //         //     const packStatus = await fetchPackageProps({ packageIds: [packageSelected?.packageId] })

    //         //     // console.log('packStatus', packStatus)

    //         //     if(packStatus.length){
    //         //         if(packStatus[0].props_value === "1"){
    //         //             throw new Error(`Selected package : ${values?.searchPackageNo} has been assigned and packed`)
    //         //         }
    //         //     }

    //         //     setFieldValue(`packages`, values.packages.concat([packageSelected]))
    //         // }

    //     }catch(error){
    //         promptMessage(false, `${error}`)
    //     }

    //     return true;
    // }

    const getSelectedDocuments = () => {
        let ids = [];

        values.rows.forEach(e1 => {

            let isExist = false

            ids.forEach(e2 => {
                if (e2?.documentId === e1.documentId) isExist = true
            })

            if (isExist === false) {
                ids.push(e1)
            }

        })

        return ids

    }

    const validateLocationSelection = () => {
        // return (selectLocationIds && selectLocationIds.length === 1)
        const selected = getLocationIds()
        return selected && selected.length === 1
    }

    const handleRemoveSelectedDocument = ({ documentId }) => {

        const newRows = values.rows.filter(i => i.documentId !== documentId)

        setFieldValue('filterDocumentId', 'all')
        setFieldValue(`rows`, newRows)

        if (newRows.length <= 0)
            setAddressKey('')

        setAllMaxQty(false)
        setDataSavedPackages([])

    }

    const RenderDocumentSummaryRow = () => {
        return (

            <Grid container spacing={1} sx={{ mt: 1 }} >

                <Grid item xs={12} sm={12} md={6}>

                    <Button
                        disabled={
                            allMaxQty
                        }
                        variant="outlined"
                        fullWidth
                        startIcon={<CommonIcons name={icons.add} />}
                        // onClick={() => handleAddItem({ rows: values.rows, setFieldValue }) }
                        onClick={() => {
                            setSearchDocumentConfig(prev => ({ ...prev, show: true }))
                        }}
                    >
                        Add Document
                    </Button>

                </Grid>

                <Grid item xs={12} sm={12} md={6} textAlign={"right"}>

                    {
                        values.rows.length > 0 &&

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={
                                        Boolean(allMaxQty)
                                    }
                                    size="small"
                                    onClick={() => {

                                        const updateStatus = !allMaxQty

                                        // setFieldValue(`package.method`, packingMethods.lumpsum.id)
                                        setAllMaxQty(updateStatus)

                                        // update all item qty to maxQty
                                        if (updateStatus === true) {

                                            // need to change packing method to lumpsum
                                            setFieldValue(`package.method`, packingMethods.lumpsum.id)

                                            setFieldValue(`rows`, values.rows.map((i, index) => ({
                                                ...i,
                                                qty: {
                                                    ...i.qty,
                                                    value: parseFloat(i.qty.maxQty) > 0 ? i.qty.maxQty : "0" // check the maxQty is not 0
                                                }
                                            })))

                                        } else {

                                            // need to change packing method to lumpsum
                                            setFieldValue(`package.method`, packingMethods.new.id)

                                            setFieldValue(`rows`, values.rows.map((i, index) => ({
                                                ...i,
                                                qty: {
                                                    ...i.qty,
                                                    value: "0"
                                                }
                                            })))
                                        }

                                    }}
                                />
                            }
                            label={
                                <Typography
                                    sx={{
                                        fontSize: 14
                                    }}
                                >
                                    Select Max
                                </Typography>
                            }
                        />
                    }

                </Grid>

                {/* <Grid item xs={12} sm={12} md={6}>
                    <TextField
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <CommonIcons name={icons.equal} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    {` /  ${values.rows.reduce((total, item) => total + parseFloat(item.qty), 0)}`}
                                </InputAdornment>
                            ),
                        }}
                        margin="normal"
                        size="small"
                        disabled
                        fullWidth
                        // name={"totalamount"}
                        label="Total Qty"
                        type="text"                                         
                        variant="outlined"
                        value={

                            getDisplayItems().reduce((total, item) => total + parseFloat(item.qty), 0)

                        }
                        // onChange={handleChange}
                        // error={touched.total && Boolean(errors.total)}
                        // helperText={touched.total && errors.total}
                    />
                </Grid> */}

            </Grid>

        )
    }

    const RenderDocumentRows = () => {

        return (
            <Box
            >
                <List
                    disablePadding
                    sx={{
                        maxHeight: 500,
                        // minHeight: 700,
                        overflow: 'auto',
                        mx: -2
                    }}
                    subheader={<li />}
                >
                    {
                        // getDisplayItems().map((item, index) => {
                        values?.rows.map((item, index) => {

                            const itemValues = item;

                            const {
                                documentNumber,
                                documentDate,
                                documentId,
                                name,
                                code,
                                qty
                            } = itemValues

                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            // get the items summary
                            // const itemsCount = data?.items.reduce((total, i) => total + parseFloat(i.qty), 10)

                            // need to check for hide or show
                            let hide = false
                            // check if the filter apply
                            if (values.filterDocumentId && values.filterDocumentId !== 'all') {
                                // items = values.rows.filter(i => i.documentId === values.filterDocumentId)
                                if (values.filterDocumentId !== documentId) {
                                    hide = true
                                }
                            }

                            const a = values.rows;// getDisplayItems();
                            let header = {};

                            // check need to show header or not
                            if (index === 0) {
                                header = {
                                    title: `${documentNumber}`,
                                    subTitle: `${documentDate}`
                                }
                            } else {

                                let prevDocumentNumber = a[index - 1]?.documentNumber

                                if (prevDocumentNumber !== documentNumber) {
                                    header = {
                                        title: `${documentNumber}`,
                                        subTitle: `${documentDate}`
                                    }
                                } else {
                                    header = {}
                                }

                            }

                            return (
                                <li key={`section-${index}`} style={{ display: hide ? 'none' : 'block' }}>
                                    <ul>
                                        {
                                            header?.title &&

                                            <ListSubheader
                                                sx={{
                                                    px: 2,
                                                    m: 0,
                                                    backgroundColor: grey[200],
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <Box>
                                                    <Typography
                                                        sx={{
                                                            color: grey[900],
                                                            fontWeight: '700'
                                                        }}
                                                    >
                                                        {`${header.title} (${header.subTitle})`}
                                                    </Typography>
                                                    {/* <Chip 
                                                        label={`${header.title}`}
                                                        size="medium"
                                                        variant="outlined"
                                                        color={"primary"}
                                                        // sx={{
                                                        //     width: '100%'
                                                        // }}
                                                    />
                                                    <Chip 
                                                        label={`${header.subTitle}`}
                                                        size="medium"
                                                        variant="outlined"
                                                        color={"primary"}
                                                        sx={{
                                                            ml: 1
                                                        }}
                                                    /> */}
                                                </Box>
                                                <Box
                                                    display={"flex"}
                                                    flexDirection={"row"}
                                                    justifyContent={"space-between"}
                                                    alignItems={"center"}
                                                >
                                                    <Chip
                                                        // icon={
                                                        //     <CommonIcons
                                                        //         name={icons.tick}
                                                        //     />
                                                        // }
                                                        label={
                                                            `${getTotalPackedQtyByDocId(itemValues.documentId)} / ${getTotalItemQtyByDocId(itemValues.documentId)}`
                                                        }
                                                        variant={
                                                            getTotalPackedQtyByDocId(itemValues.documentId) === getTotalItemQtyByDocId(itemValues.documentId) ?
                                                                `contained` : `outlined`
                                                        }
                                                        size="small"
                                                        sx={{
                                                            backgroundColor: getTotalPackedQtyByDocId(itemValues.documentId) === getTotalItemQtyByDocId(itemValues.documentId) ?
                                                                green[400] : `default`
                                                        }}
                                                    />
                                                    <IconButton
                                                        size="small"
                                                        // color="danger"
                                                        sx={{
                                                            color: red[500]
                                                        }}
                                                        onClick={() => {
                                                            // console.log('delete', i.documentId)
                                                            handleRemoveSelectedDocument({ documentId })
                                                        }}
                                                    >
                                                        <CommonIcons name={icons.cancel} />
                                                    </IconButton>
                                                </Box>
                                            </ListSubheader>
                                        }
                                        <ListItem
                                            key={index}
                                            divider
                                            disablePadding
                                            sx={{
                                                px: 2,
                                                py: 0.5
                                            }}
                                            selected={
                                                Boolean(itemValues?.qty?.value && parseFloat(itemValues.qty.value) > 0)
                                            }
                                        >
                                            <Grid item xs={12} sm={12} md={12}>

                                                <Grid container spacing={1} >

                                                    <Grid item xs={12} sm={12} md={0.5} display={"flex"} justifyContent={"center"} alignItems={"center"}>

                                                        {
                                                            checkDocItemIsDone(itemValues.docItemId) ?
                                                                (
                                                                    <CommonIcons
                                                                        name={icons.tick}
                                                                        sx={{
                                                                            color: green[500],
                                                                            width: 50,
                                                                            height: 50
                                                                        }}
                                                                    />
                                                                )
                                                                :
                                                                (
                                                                    <CommonIcons name={icons.chevronRight} />
                                                                )
                                                        }


                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={7}>

                                                        <ListItemText
                                                            primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{name}</Typography>}
                                                            secondary={<Typography sx={{ fontSize: 12 }}>{`Code : ${code}`}</Typography>}
                                                        />

                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={2} textAlign={"center"}>
                                                        <ListItemText
                                                            primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{itemValues?.qty?.itemQty ? itemValues.qty.itemQty : ""}</Typography>}
                                                            secondary={<Typography sx={{ fontSize: 12 }}>{`${itemValues?.uomName}`}</Typography>}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={2.5} textAlign={"right"}>
                                                        {/* {
                                                            JSON.stringify(itemValues.qty.maxQty)
                                                        } */}
                                                        <TextField
                                                            disabled={
                                                                // getMaxQtyByDocItemId(itemValues.docItemId) <= 0
                                                                itemValues.qty.maxQty <= 0
                                                                ||
                                                                allMaxQty === true
                                                            }
                                                            margin="dense"
                                                            size="small"
                                                            // autoFocus
                                                            fullWidth
                                                            name={"qty"}
                                                            label="Qty"
                                                            type="text"
                                                            variant="outlined"
                                                            value={
                                                                itemValues?.qty?.value ? itemValues.qty.value : ""
                                                            }
                                                            onChange={(e) => {
                                                                setFieldValue(`rows.${index}.qty`, {
                                                                    value: e.target.value,
                                                                    maxQty: parseFloat(itemValues.qty.maxQty),
                                                                    // maxQty: getMaxQtyByDocItemId(itemValues.docItemId),
                                                                    itemQty: itemValues.qty.itemQty
                                                                })
                                                            }}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        {` / ${(itemValues.qty.maxQty)}`}
                                                                        {/* {` / ${getMaxQtyByDocItemId(itemValues.docItemId)}`} */}
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                            onFocus={event => {
                                                                event.target.select();
                                                            }}
                                                            error={Boolean(itemErrors?.qty?.value)}
                                                            helperText={itemErrors?.qty?.value}
                                                            autoComplete="off"
                                                        />

                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                    </ul>
                                </li>
                            )
                        })
                    }
                </List>

                {/* <Grid item xs={12}>
                    <Divider sx={{ mt: 1, mb: 0 }} />
                </Grid> */}

                {
                    (getSelectedDocuments().length <= 0) &&
                    <RenderDefaultSelection />
                }

                {
                    RenderDocumentSummaryRow()
                }

            </Box>
        )
    }

    const RenderPackagePreview = () => {

        const getRows = () => {

            return values.rows.filter(i => parseFloat(i.qty.value) > 0)

        }

        return (
            <TableContainer
            // component={Paper}
            >
                <Table
                    // sx={{ minWidth: 650 }} 
                    aria-label="simple table"
                    size="small"
                >
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">No.</TableCell>
                            <TableCell align="left" width={160}>Document</TableCell>
                            <TableCell align="left">Item</TableCell>
                            <TableCell align="right">Qty</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            getRows().map((row, index) => (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" align="center" scope="row" sx={{ width: 40 }}>
                                        {(index + 1)}
                                    </TableCell>
                                    <TableCell align="left">
                                        <ListItemText
                                            primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{row.documentNumber}</Typography>}
                                            secondary={<Typography sx={{ fontSize: 12 }}>{row.documentDate}</Typography>}
                                        />
                                    </TableCell>
                                    <TableCell align="left">
                                        <ListItemText
                                            primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{row.name}</Typography>}
                                            secondary={<Typography sx={{ fontSize: 12 }}>{row.code}</Typography>}
                                        />
                                    </TableCell>
                                    <TableCell align="right">{row.qty.value}</TableCell>
                                </TableRow>
                            ))
                        }
                        {/* <TableRow>
                            <TableCell align="right" colSpan={3}>Total Qty</TableCell>
                            <TableCell align="right">{totalQty}</TableCell>
                        </TableRow>  */}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    const RenderFormPackages = () => {

        const totalQty = getTotalQtySelected()

        return (
            <>
                <Grid container spacing={1}>
                    <Grid item xs={6} sm={6} md={6} textAlign={"left"}>

                        <Box sx={{ pl: 1 }}>
                            <Typography
                                sx={{
                                    fontWeight: '700',
                                    pt: 0,
                                    // pl: 1,
                                    textAlign: 'left',
                                    fontSize: 20
                                }}
                            >
                                Preview Package
                            </Typography>
                            <Typography
                                sx={{
                                    // fontWeight: '700',
                                    pt: -2,
                                    // pl: 1,
                                    textAlign: 'left',
                                    fontSize: 13
                                }}
                            >
                                Related packages to pack completion
                            </Typography>
                        </Box>

                    </Grid>

                    <Grid item xs={6} sm={6} md={6} textAlign={"left"} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>

                        <Box
                            display={"flex"}
                            justifyContent={"center"}
                            alignItems={"center"}
                            sx={{
                                backgroundColor: grey[800],
                                px: 1,
                                borderRadius: 1,
                                // borderColor: grey[500],
                                // borderWidth: 1,
                                // borderStyle: 'solid'
                            }}
                        >
                            <CommonIcons
                                name={icons.products}
                                sx={{
                                    color: grey[100]
                                }}
                            />
                            <Typography
                                sx={{
                                    fontSize: 25,
                                    ml: 1,
                                    color: grey[100]
                                }}
                            >
                                {totalQty}
                            </Typography>
                        </Box>

                    </Grid>
                </Grid>

                <StyledCard sx={{ mt: 1, p: 0 }}>

                    {
                        totalQty <= 0 ?
                            (
                                <RenderDefaultSelection />
                            )
                            :
                            (
                                RenderPackagePreview()
                            )
                    }

                </StyledCard>
            </>
        )
    }

    const RenderDefaultSelection = ({ children }) => {
        return (
            <Box
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                    backgroundColor: grey[100],
                    minHeight: 200,
                    borderRadius: 1,
                }}
            >
                {
                    children && children
                }
                {
                    !children &&
                    (
                        <Typography
                            sx={{
                                color: grey[400],
                                textAlign: 'center',
                            }}
                        >
                            {`No Selection`}
                        </Typography>
                    )
                }
            </Box>
        )
    }

    const RenderFormLocation = () => {
        return (
            <StyledCard>
                <Grid container spacing={1}>
                    <Grid item xs={6} sm={6} md={6} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Location`}
                            subTitle={`Related warehouse location to process`}
                        />

                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                        <TextField
                            disabled
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"locationId"}
                            label="Location"
                            type="text"
                            variant="outlined"
                            value={values.locationDisplay}
                            error={touched.locationId && Boolean(errors.locationId)}
                            helperText={touched.locationId && errors.locationId}
                            InputProps={{
                                sx: {
                                    pr: 1
                                },
                                endAdornment: (
                                    <IconButton
                                        onClick={() => { setLocationIds([]) }}
                                        color="primary"
                                        size="small"
                                    >
                                        <CommonIcons name={icons.edit} />
                                    </IconButton>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderFormPackingMethodHeader = () => {

        if (!packingMethods) return <></>

        const getPackingMethodDescription = (id) => {
            const selected = Object.keys(packingMethods).filter(i => i === id)

            if (selected.length) {
                return packingMethods[selected[0]].description
            }

            return ""
        }

        return (
            <>
                <Box sx={{ pl: 1 }}>
                    <Typography
                        sx={{
                            fontWeight: '700',
                            pt: 2,
                            // pl: 1,
                            textAlign: 'left',
                            fontSize: 20
                        }}
                    >
                        Choose Packing Method
                    </Typography>
                    <Typography
                        sx={{
                            // fontWeight: '700',
                            pt: -2,
                            // pl: 1,
                            textAlign: 'left',
                            fontSize: 13
                        }}
                    >
                        {getPackingMethodDescription(values.package.method)}
                    </Typography>
                </Box>
            </>
        )
    }

    const RenderFormPackingMethodNew = () => {
        return (
            <>
                <FormControl
                    margin="dense"
                    fullWidth
                    size="small"
                    error={Boolean(errors?.package?.uomId)}
                >
                    <InputLabel id="packageUomId">Package Uom</InputLabel>
                    <Select
                        disabled={
                            (values.rows.reduce((total, i) => total + parseFloat(i.qty.value), 0) <= 0)
                        }
                        labelId="packageUomId"
                        label="packageUomId"
                        name={`package.uomId`}
                        onChange={(event) => {

                            setFieldValue(`package.uomId`, event.target.value)

                            const selected = dataUoms.filter(i => i.id === event.target.value)

                            if (selected.length)
                                setFieldValue(`package.uomName`, selected[0]?.name)

                        }}
                        sx={{
                            textAlign: 'left',
                        }}
                        MenuProps={{
                            MenuListProps: {
                                sx: {
                                    py: 0
                                },
                            }
                        }}
                        value={values?.package?.uomId ? values.package.uomId : ""}
                    >
                        {/* <RenderSubHeaderComponent /> */}
                        {
                            dataUoms.map((i, index) => {
                                return (
                                    // <RenderMenuItemComponent
                                    //     key={index2}
                                    //     index={index2}
                                    //     item={i}
                                    // />
                                    // RenderMenuItemComponent({
                                    //     key: index2,
                                    //     index: index2,
                                    //     item: i
                                    // })
                                    <MenuItem
                                        key={index}
                                        value={i.id}
                                        sx={{
                                            textTransform: 'capitalize',
                                            px: 1.5,
                                            fontSize: 14
                                        }}
                                        disableGutters
                                        divider
                                    >
                                        {i.name}
                                    </MenuItem>
                                )
                            })
                        }
                    </Select>
                    <FormHelperText>
                        {
                            errors?.package?.uomId
                        }
                    </FormHelperText>
                </FormControl>
                <TextField
                    margin="dense"
                    size="small"
                    autoFocus
                    fullWidth
                    name={"package.remark"}
                    label="Remark"
                    type="text"
                    variant="outlined"
                    value={values?.package?.remark ? values.package.remark : ""}
                    onChange={handleChange}
                    error={Boolean(errors?.package?.remark)}
                    helperText={errors?.package?.remark}
                    rows={3}
                    multiline
                    // InputProps={{
                    //     style:{
                    //         paddingRight: 1
                    //     },
                    //     endAdornment: (
                    //         <IconButton
                    //             onClick={() => { handleSearchPackage() }}
                    //         >
                    //             <CommonIcons name={icons.search} />
                    //         </IconButton>
                    //     ),
                    // }}
                    autoComplete="off"
                />
            </>
        )
    }

    const RenderFormPackingMethodExisting = () => {
        return (
            <>
                <TextField
                    margin="dense"
                    size="small"
                    autoFocus
                    fullWidth
                    name={"package.packageNo"}
                    label="Package No."
                    type="text"
                    variant="outlined"
                    value={values?.package?.packageNo ? values.package.packageNo : ""}
                    onChange={handleChange}
                    error={Boolean(errors?.package?.packageNo)}
                    helperText={errors?.package?.packageNo}
                    // InputProps={{
                    //     style:{
                    //         paddingRight: 1
                    //     },
                    //     endAdornment: (
                    //         <IconButton
                    //             onClick={() => { handleSearchPackage() }}
                    //         >
                    //             <CommonIcons name={icons.search} />
                    //         </IconButton>
                    //     ),
                    // }}
                    autoComplete="off"
                />

                <TextField
                    margin="dense"
                    size="small"
                    autoFocus
                    fullWidth
                    name={"package.remark"}
                    label="Remark"
                    type="text"
                    variant="outlined"
                    value={values?.package?.remark ? values.package.remark : ""}
                    onChange={handleChange}
                    error={Boolean(errors?.package?.remark)}
                    helperText={errors?.package?.remark}
                    rows={3}
                    multiline
                    // InputProps={{
                    //     style:{
                    //         paddingRight: 1
                    //     },
                    //     endAdornment: (
                    //         <IconButton
                    //             onClick={() => { handleSearchPackage() }}
                    //         >
                    //             <CommonIcons name={icons.search} />
                    //         </IconButton>
                    //     ),
                    // }}
                    autoComplete="off"
                />

            </>
        )
    }

    const RenderFormPackingMethodLumpsum = () => {

        // need to check whether the related documents has created any package before (block if there is any package created)
        if (dataSavedPackages.length > 0) {
            return (
                <RenderDefaultSelection>
                    <CommonIcons name={icons.disabled} sx={{ width: 60, height: 60, color: grey[500] }} />
                    <Typography
                        sx={{
                            color: grey[700],
                            display: 'inline'
                        }}
                    >
                        {`There is ${dataSavedPackages.length} packages created.`}
                    </Typography>
                    <Typography
                        sx={{
                            color: grey[700],
                            display: 'inline'
                        }}
                    >
                        {`This method only allowed with no package assigned`}
                    </Typography>
                </RenderDefaultSelection>
            )
        }


        return (
            <>
                {
                    RenderLumpsumRows()
                }
            </>
        )
    }

    const RenderLumpsumSummaryRows = () => {
        return (

            <Grid container spacing={1} sx={{ mt: 1 }} >

                <Grid item xs={12} sm={12} md={6}>

                    <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<CommonIcons name={icons.add} />}
                        // onClick={() => handleAddItem({ rows: values.rows, setFieldValue }) }
                        onClick={() => {

                            setFieldValue(`package.packages`, [...values.package.packages, initialPackagePackagesRowValues])

                        }}
                    >
                        Add Package
                    </Button>

                </Grid>

                {/* <Grid item xs={12} sm={12} md={6}>
                    <TextField
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <CommonIcons name={icons.equal} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    {` /  ${values.rows.reduce((total, item) => total + parseFloat(item.qty), 0)}`}
                                </InputAdornment>
                            ),
                        }}
                        margin="normal"
                        size="small"
                        disabled
                        fullWidth
                        // name={"totalamount"}
                        label="Total Qty"
                        type="text"                                         
                        variant="outlined"
                        value={

                            getDisplayItems().reduce((total, item) => total + parseFloat(item.qty), 0)

                        }
                        // onChange={handleChange}
                        // error={touched.total && Boolean(errors.total)}
                        // helperText={touched.total && errors.total}
                    />
                </Grid> */}

            </Grid>

        )
    }

    const RenderLumpsumRows = () => {

        return (
            <Box
            >
                <List
                    disablePadding
                    sx={{
                        maxHeight: 500,
                        // minHeight: 700,
                        overflow: 'auto',
                        mx: -2
                    }}
                    subheader={<li />}
                >
                    {
                        values?.package?.packages.map((item, index) => {

                            const itemValues = item;

                            let itemTouched = touched?.package?.packages
                            let itemErrors = errors?.package?.packages

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            return (
                                <li key={`section-${index}`}>
                                    <ul>
                                        <ListItem
                                            key={index}
                                            divider
                                            disablePadding
                                            sx={{
                                                px: 2,
                                                py: 0.5
                                            }}
                                        >
                                            <Grid item xs={12} sm={12} md={12}>

                                                <Grid container spacing={1} >

                                                    <Grid item xs={12} sm={12} md={1} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>

                                                        <CommonIcons name={icons.package} />

                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={3} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>

                                                        <Typography>
                                                            {
                                                                `Package #${(index + 1)}`
                                                            }
                                                        </Typography>

                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={2.5} textAlign={"right"}>
                                                        {/* {
                                                            JSON.stringify(itemValues.qty)
                                                        } */}
                                                        <TextField
                                                            margin="dense"
                                                            size="small"
                                                            // autoFocus
                                                            fullWidth
                                                            name={`package.packages.${index}.qty`}
                                                            label="Qty"
                                                            type="text"
                                                            variant="outlined"
                                                            value={
                                                                itemValues?.qty ? itemValues.qty : ""
                                                            }
                                                            onChange={handleChange}
                                                            // onChange={(e) => {
                                                            //     setFieldValue(`rows.${index}.qty`, {
                                                            //         value: e.target.value,
                                                            //         // maxQty: parseFloat(itemValues.qty.maxQty)
                                                            //         maxQty: getMaxQtyByDocItemId(itemValues.docItemId),
                                                            //         itemQty: itemValues.qty.itemQty
                                                            //     })
                                                            // }}
                                                            // InputProps={{
                                                            //     endAdornment: (
                                                            //         <InputAdornment position="end">
                                                            //             {/* {` / ${(itemValues.qty.maxQty)}00`} */}
                                                            //             {` / ${getMaxQtyByDocItemId(itemValues.docItemId)}`}
                                                            //         </InputAdornment>
                                                            //     ),
                                                            // }}
                                                            onFocus={event => {
                                                                event.target.select();
                                                            }}
                                                            error={Boolean(itemErrors?.qty)}
                                                            helperText={itemErrors?.qty}
                                                            autoComplete="off"
                                                        />

                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={4.5}>

                                                        <FormControl
                                                            margin="dense"
                                                            fullWidth
                                                            size="small"
                                                            error={Boolean(itemErrors?.uomId)}
                                                        >
                                                            <InputLabel id="packageUomId">Package Uom</InputLabel>
                                                            <Select
                                                                disabled={
                                                                    (values.rows.reduce((total, i) => total + parseFloat(i.qty.value), 0) <= 0)
                                                                }
                                                                labelId="packageUomId"
                                                                label="packageUomId"
                                                                name={`package.packages.${index}.uomId`}
                                                                onChange={(event) => {

                                                                    setFieldValue(`package.packages.${index}.uomId`, event.target.value)

                                                                    const selected = dataUoms.filter(i => i.id === event.target.value)

                                                                    if (selected.length)
                                                                        setFieldValue(`package.packages.${index}.uomName`, selected[0]?.name)

                                                                }}
                                                                sx={{
                                                                    textAlign: 'left',
                                                                }}
                                                                MenuProps={{
                                                                    MenuListProps: {
                                                                        sx: {
                                                                            py: 0
                                                                        },
                                                                    }
                                                                }}
                                                                value={itemValues?.uomId ? itemValues.uomId : ""}
                                                            >
                                                                {/* <RenderSubHeaderComponent /> */}
                                                                {
                                                                    dataUoms.map((i, index) => {
                                                                        return (
                                                                            // <RenderMenuItemComponent
                                                                            //     key={index2}
                                                                            //     index={index2}
                                                                            //     item={i}
                                                                            // />
                                                                            // RenderMenuItemComponent({
                                                                            //     key: index2,
                                                                            //     index: index2,
                                                                            //     item: i
                                                                            // })
                                                                            <MenuItem
                                                                                key={index}
                                                                                value={i.id}
                                                                                sx={{
                                                                                    textTransform: 'capitalize',
                                                                                    px: 1.5,
                                                                                    fontSize: 14
                                                                                }}
                                                                                disableGutters
                                                                                divider
                                                                            >
                                                                                {i.name}
                                                                            </MenuItem>
                                                                        )
                                                                    })
                                                                }
                                                            </Select>
                                                            <FormHelperText>
                                                                {
                                                                    itemErrors?.uomId
                                                                }
                                                            </FormHelperText>
                                                        </FormControl>

                                                    </Grid>

                                                    <Grid item xs={12} sm={12} md={1} justifyContent={"center"} alignItems={"center"} display={"flex"}>
                                                        <IconButton
                                                            sx={{
                                                                color: red[500]
                                                            }}
                                                            onClick={() => {

                                                                // check the min rows
                                                                if (values.package.packages.length <= 1) {
                                                                    promptMessage(false, `Min (1) row of package`)
                                                                    return false
                                                                }

                                                                setFieldValue(`package.packages`, values.package.packages.filter((i, index2) => index2 !== index))

                                                                return true;

                                                            }}
                                                        >
                                                            <CommonIcons name={icons.cancel} />
                                                        </IconButton>
                                                    </Grid>

                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                    </ul>
                                </li>
                            )
                        })
                    }
                </List>

                {
                    RenderLumpsumSummaryRows()
                }

                <Box
                    sx={{ mt: 1 }}
                >
                    <TextField
                        margin="dense"
                        size="small"
                        autoFocus
                        fullWidth
                        name={"package.remark"}
                        label="Remark"
                        type="text"
                        variant="outlined"
                        value={values?.package?.remark ? values.package.remark : ""}
                        onChange={handleChange}
                        error={Boolean(errors?.package?.remark)}
                        helperText={errors?.package?.remark}
                        rows={3}
                        multiline
                        // InputProps={{
                        //     style:{
                        //         paddingRight: 1
                        //     },
                        //     endAdornment: (
                        //         <IconButton
                        //             onClick={() => { handleSearchPackage() }}
                        //         >
                        //             <CommonIcons name={icons.search} />
                        //         </IconButton>
                        //     ),
                        // }}
                        autoComplete="off"
                    />
                </Box>


            </Box>
        )
    }

    const RenderFormPackingMethod = () => {

        const totalQty = getTotalQtySelected()

        if (totalQty <= 0) return <></>

        return (
            <>
                <RenderFormPackingMethodHeader />

                <StyledCard sx={{ mt: 1, p: 0, pt: 0 }}>

                    <Box sx={{}}>
                        <ButtonGroup
                            fullWidth
                            variant="outlined"
                            aria-label="outlined primary button group"
                            sx={{
                                // mt: 1
                            }}
                        >
                            <Button
                                disabled={
                                    // check only enabled if the check all max qty applied
                                    allMaxQty === false
                                }
                                variant={values.package.method === packingMethods.lumpsum.id ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFieldValue(`package`, {
                                        ...values.package,
                                        method: packingMethods.lumpsum.id
                                    })
                                }}
                            >
                                One Time Lumpsum
                            </Button>
                            <Button
                                variant={values.package.method === packingMethods.existing.id ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFieldValue(`package`, {
                                        ...values.package,
                                        method: packingMethods.existing.id
                                    })
                                }}
                            >
                                Existing Package
                            </Button>
                            <Button
                                variant={values.package.method === packingMethods.new.id ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFieldValue(`package`, {
                                        ...values.package,
                                        method: packingMethods.new.id
                                    })
                                }}
                            >
                                New Package
                            </Button>
                        </ButtonGroup>
                    </Box>

                    <Box sx={{ p: 2 }}>
                        {
                            values.package.method === packingMethods.new.id &&
                            RenderFormPackingMethodNew()
                        }

                        {
                            values.package.method === packingMethods.existing.id &&
                            RenderFormPackingMethodExisting()
                        }

                        {
                            values.package.method === packingMethods.lumpsum.id &&
                            RenderFormPackingMethodLumpsum()
                        }
                    </Box>

                </StyledCard>
            </>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard sx={{ mt: 1 }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Documents`}
                            subTitle={`Basic information about the documents`}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        {/* {JSON.stringify(values?.filterDocumentId)} */}

                        {
                            getSelectedDocuments().length > 0 &&

                            <FormControl
                                margin="dense"
                                fullWidth
                                size="small"
                            // error={Boolean(itemErrors?.inventoryBatchId)}
                            >
                                <InputLabel id="documents">Filter</InputLabel>
                                <Select
                                    // disabled={
                                    //     !(itemValues?.itemId)
                                    // }
                                    // labelId="inventoryBatchId"
                                    label="Filter"
                                    // name={`rows.${index}.inventoryBatchId`}
                                    // onChange={handleChange}
                                    onChange={(event) => {
                                        setFieldValue(`filterDocumentId`, event.target.value)
                                    }}
                                    value={
                                        (
                                            values?.filterDocumentId === "all" ?
                                                "all"
                                                :
                                                checkValueExists({
                                                    searchFieldId: "documentId",
                                                    dataSearch: getSelectedDocuments(),
                                                    valueToCompare: values?.filterDocumentId
                                                })
                                        )
                                        // values?.filterDocumentId
                                    }
                                    renderValue={(id) => {
                                        const selected = getSelectedDocuments().filter(i => i.documentId === id)

                                        if (selected && selected.length > 0) {
                                            return (
                                                <>
                                                    {selected[0].documentNumber}
                                                </>
                                            )
                                        }

                                        return <>Show All</>

                                    }}
                                >
                                    <MenuItem
                                        key={0}
                                        value={'all'}
                                        sx={{
                                            textTransform: 'capitalize',
                                        }}
                                    >
                                        Show All
                                    </MenuItem>

                                    {
                                        getSelectedDocuments().map((i, index) => {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    value={i.documentId}
                                                    sx={{
                                                        // textTransform: 'capitalize',
                                                        // display: 'flex',
                                                        // flexDirection: 'row',
                                                        // justifyContent: 'space-between',
                                                        // alignItems: 'center'
                                                    }}
                                                >
                                                    {i.documentNumber}
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                                {/* <FormHelperText>
                                    {
                                        itemErrors?.inventoryBatchId?
                                            itemErrors?.inventoryBatchId
                                            :
                                            getSelectedInventoryBatch({ selectedIndexNo: index })?.batchId?
                                                getSelectedInventoryBatch({ selectedIndexNo: index }).label
                                                :
                                                ""
                                    }
                                </FormHelperText> */}
                            </FormControl>

                        }

                    </Grid>
                    {
                        addressKey &&
                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                            <Box
                                display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"flex-start"}
                                alignItems={"center"}
                                sx={{
                                    backgroundColor: grey[800],
                                    py: 1,
                                    px: 1,
                                    mx: -2,
                                    mb: -1
                                }}
                            >
                                <CommonIcons name={icons.logistic} sx={{ color: grey[100] }} />
                                <Typography
                                    sx={{
                                        color: grey[100],
                                        ml: 1
                                    }}
                                >
                                    {addressKey.replace(/::/g, " ")}
                                </Typography>
                            </Box>
                        </Grid>
                    }

                    <Grid item xs={12} sm={12} md={12}>
                        {
                            RenderDocumentRows()
                        }
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderFormActions = () => {

        // calculate any packages saved
        const totalSavedPackages = dataSavedPackages.length

        // console.log('dataSavedPackages', dataSavedPackages)

        let params = new URLSearchParams();

        // get unique url get
        if (totalSavedPackages) {
            let array = getUniqueValuesInArray({ array: values.rows, uniqueKey: "documentNumber" }).map(i => (
                encodeURIComponent(i)
            ))

            // console.log('array', array)
            // array.forEach(i => {
            params.set("docNumbers", array);
            // })
        }

        return (
            <Grid container spacing={1} sx={{ mt: 1, px: 1 }}>
                <Grid item xs={12} sm={12} md={6}>
                    {
                        totalSavedPackages > 0 &&
                        <Button
                            variant="contained"
                            color={"warning"}
                            onClick={() => {
                                openRelatedPackages()
                            }}
                        >
                            {`Found ${totalSavedPackages} Packages`}
                        </Button>
                        // <Button
                        //     variant="contained"
                        //     color={"warning"}
                        // >
                        //     <Link
                        //         href={getRoute(`repositories/package/view?${params.toString()}`)}
                        //         target="_blank"
                        //         underline="none"
                        //         rel="noopener"
                        //         color={"warning"}
                        //         sx={{
                        //             display: 'flex',
                        //             flexDirection: 'row',
                        //             justifyContent: 'space-between',
                        //             alignItems: 'center',
                        //         }}
                        //     >
                        //         <CommonIcons name={icons.info} sx={{ mr: 1 }} />
                        //         {`Found ${totalSavedPackages} Packages`}
                        //     </Link>
                        // </Button>

                    }
                </Grid>
                <Grid item xs={12} sm={12} md={6} textAlign={"right"}>
                    <Button
                        disabled={
                            getTotalQtySelected() <= 0
                        }
                        variant="contained"
                        color={"primary"}
                        type="submit"
                    >
                        Save Changes
                    </Button>
                </Grid>
            </Grid >
        )
    }

    const RenderForm = () => {

        // if(!values) return <></>

        return (
            <form onSubmit={handleSubmit}>
                {/* {
                        JSON.stringify(errors)
                    } */}
                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                        {
                            RenderFormLocation()
                        }
                        {
                            RenderFormDocument()
                        }
                    </Grid>


                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>



                        {
                            RenderFormPackages()
                        }

                        {
                            RenderFormPackingMethod()
                        }

                        {
                            RenderFormActions()
                        }

                    </Grid>

                </Grid>

            </form>
        )
    }

    const RenderAll = () => {
        return validateLocationSelection() ?
            (
                RenderForm()
            )
            :
            (
                <LocationSelector
                    config={{
                        title: "Select Only (1) Location",
                        description: "You have to select anyone of the warehouse location to proceed"
                    }}
                    maxSelect={1}
                    handleOnNext={({ selected }) => {

                        setLocationIds([selected[0].id])
                        setFieldValue(`locationId`, selected[0].id)
                        setFieldValue(`locationDisplay`, selected[0].location_name)

                    }}
                />
            )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.deliveryOrders })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle="Package Packing"
                breadcrumbs={[
                    {
                        displayText: "Packages",
                        props: {
                            href: getRoute('repositories/packages')
                        }
                    },
                    {
                        displayText: "Package Packing",
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pagePack.id }) ?
                    RenderAll()
                    :
                    (
                        <CommonRestricted />
                    )
            }

            {
                searchDocumentConfig?.show &&

                <SearchPackDocuments
                    id={`0`}
                    config={
                        {
                            allowDocumentTypes: searchDocumentConfig?.documentType,
                            presetDocumentType: searchDocumentConfig?.presetDocumentType,
                            filterKeyword: searchDocumentConfig?.keyword
                        }
                    }
                    show={searchDocumentConfig.show}
                    handleOnCancel={() => {
                        setSearchDocumentConfig(prev => ({ ...prev, show: false }))
                    }}
                    handleOnSearchChange={(event) => {
                        // setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                    }}
                    handleOnSelect={async (props) => {

                        try {
                            setSearchDocumentConfig(prev => ({ ...prev, show: false }))

                            // check the address is same
                            checkSameAddress({ data: props?.data })

                            // need to check whether the document selected is in the list
                            const checkDuplicate = await checkDocumentIsSelected({ documentId: props?.id })

                            if (checkDuplicate) {
                                throw new Error(`Document : ${props?.data?.document?.doc_number} already selected`)
                            }

                            let newItems = [];

                            // console.log('da', props)

                            props?.data.items.forEach((e1) => {
                                const newItem = {
                                    ...initialRowValues,
                                    documentId: props?.id,
                                    documentDate: props?.data?.document?.doc_date,
                                    documentNumber: props?.data?.document?.doc_number,
                                    docItemId: e1.id,
                                    itemId: e1.item_id,
                                    name: e1.item_name,
                                    code: e1.code,
                                    description: e1?.description,
                                    price: e1?.uom_price,
                                    uomId: e1?.uom_id,
                                    uomName: e1?.uom_name,
                                    qty: {
                                        value: "0",
                                        // maxQty: parseFloat(e1.qty),
                                        maxQty: getMaxQtyByDocItemId(e1.id),
                                        itemQty: parseFloat(e1.qty)
                                    },
                                    data: JSON.stringify(e1)
                                }
                                newItems.push(newItem)
                            })

                            const newRows = values.rows.concat(newItems)

                            setFieldValue(`rows`, newRows)

                            // reset the max select option
                            setAllMaxQty(false)

                        } catch (error) {
                            promptMessage(false, `Selection Failed : ${error}`)
                        }

                        return true;

                    }}
                    textProps={{
                        disabled: true,
                        // value: itemValues?.name? itemValues.name : "",
                        // error: Boolean(itemErrors?.name),
                        // helperText: itemErrors?.name
                    }}
                />
            }

        </Box>
    )
}